import { getData } from "../apiClient";

const API_URL = "loan-report";

// get loan reports with pagination
export const getLoanReportsWithPagination = async ({ page = 1, limit = 10, search = "", ...rest }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
            ...rest
        });

        const result = await getData(`/${API_URL}/list?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Loan Report with pagination API error:", error);
        return {
            success: false,
            error: error.message,
        };
    }
};

// get employees list for report filter
export const GetReportEmployeeList = async (signal = null) => {
    try {
        const result = await getData(`/${API_URL}/employees`, {}, {}, signal);
        return {
            success: true,
            data: result,
        };
    } catch (error) {
        console.error("Get Report Employee List API error:", error);
        return {
            success: false,
            error: error.message,
        };
    }
};

export const GetEmployeeDetails = async (id, signal = null) => {
    try {
        const result = await getData(`/${API_URL}/employee/${id}`, {}, {}, signal);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Employee Details API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
                status: error.status,
            },
        };
    }
};

export const GetInstallmentsByLoanId = async (id, signal = null) => {
    try {
        const result = await getData(`/${API_URL}/installments/${id}`, {}, {}, signal);
        return {
            success: true,
            data: result,
        };
    } catch (error) {
        console.error("Get Installments by Loan ID API error:", error);
        return {
            success: false,
            error: error.message,
        };
    }
};
